import React, { useEffect, useState } from 'react';
import { SimpleGrid, Group, Card, Text, Avatar } from '@mantine/core';
import { useAllUsersQuery } from '../endpoints/user';
import { IconChevronRight } from '@tabler/icons-react';
const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
const OperationsUserPage = ({ updatePage }) => {
  const users = useAllUsersQuery();
  const [userData, setUserData] = useState([]);
  const regexPattern = /([a-zA-Z]).*?([a-zA-Z])/;
  useEffect(() => {
    if (!users.isLoading && users.isSuccess) {
      setUserData([...users.data].sort((a, b) => a.id - b.id) ?? []);
    }
  }, [users]);

  return (
    <div>
      <Text size="lg" fw={700} pb={10}>
        Select User Account
      </Text>
      <SimpleGrid cols={1} verticalSpacing="md">
        {userData.map((user) => (
          <Card
            padding="lg"
            radius="md"
            withBorder
            key={user.id}
            style={{ cursor: 'pointer' }}
            onClick={() => updatePage(user)}
          >
            <Group>
              <Avatar round="25px" size="50px" color={getRandomColor()}>
                {`${user.username
                  .match(regexPattern)[1]
                  .toUpperCase()}${user.username
                  .match(regexPattern)[2]
                  .toUpperCase()}`}
              </Avatar>

              <Text size="md" fw={500}>
                {user.username}
              </Text>
              <IconChevronRight style={{ marginLeft: 'auto' }} />
            </Group>
          </Card>
        ))}
      </SimpleGrid>
    </div>
  );
};

export default OperationsUserPage;
